import { text } from '@storybook/addon-knobs';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import {
  ProgressBarComponent,
  TInvestmentReturnProgressProps,
} from './progressBar';
import { TInvestmentReturn } from '../models/investmentReturn.model';

let height = 50;
let investmentAmount = 10000;
let investmentReturnModels: TInvestmentReturnProgressProps[] = [];
let allSeries: TInvestmentReturn[] = [
  {
    Gain: 4000,
    GainPercent: 4,
    Loss: -1100,
    LossPercent: -11,
    AverageReturn: 2500,
    AverageReturnPercent: 2.5,
    Key: 1,
  },
];

let seriesReturns: TInvestmentReturn = {
  Gain: 4000,
  GainPercent: 4,
  Loss: -1100,
  LossPercent: -11,
  AverageReturn: 2500,
  AverageReturnPercent: 2.5,
  Key: 1,
};

investmentReturnModels.push(
  {
    allSeries,
    height,
    investmentAmount,
    seriesReturns,
  },
  {
    allSeries,
    height,
    investmentAmount,
    seriesReturns,
  },
);

storiesOf('Progress Bar', module)
  .add('with single return', () => {
    return (
      <ProgressBarComponent
        height={height}
        investmentAmount={investmentAmount}
        allSeries={allSeries}
        seriesReturns={seriesReturns}
      />
    );
  })
  .add('with multiple returns', () => {
    return (
      <div className="row">
        {investmentReturnModels.map((model, index) => {
          return (
            <div className={`col-2 bar `} key={index}>
              <ProgressBarComponent
                height={height}
                investmentAmount={investmentAmount}
                allSeries={allSeries}
                seriesReturns={seriesReturns}
              />
            </div>
          );
        })}
      </div>
    );
  });
